export enum BIM360IssueActivityType {
    VIEW = 'quality-issue-view',
    ATTACH = 'quality-issue-attach',
    CREATE = 'quality-issue-create',
    COMMENT = 'quality-issue-comment',
    OPEN = 'quality-issue-open',
    CLOSED = 'quality-issue-closed',
    ANSWERED = 'quality-issue-answered',
    ASSIGN = 'quality-issue-assign',
    VOID = 'quality-issue-void',
    DUE_DATE = 'quality-issue-due-date',
    EDIT = 'quality-issue-edit',
}

export abstract class BIM360IssueActivityChange {
    public property: string = '';
    public before: string | object = '';
    public after: string | object = '';
}

export abstract class BIM360IssueActivityChanges {
    public changes: BIM360IssueActivityChange[] = [];
    public datetime: string = '';
    public type!: BIM360IssueActivityType;
}

export abstract class BIM360IssueActivity {
    public id: string = '';
    static type: string = 'activity_batches';
    public activities: BIM360IssueActivityChanges[] = [];
    public date: string = '';
    public user: string = '';
}

// export abstract class BIM360IssueActivities {
//     public actor: string = '';
//     public first_activity_date: string = '';
//     public activities: BIM360IssueActivity[] = [];
// }